import axios from "axios";
import { CHAT_BASE_URL } from "../utils/SnpChatConstant"
import { printChatDebugLog } from "../utils/SnpChatUtils";



const chatAxios = axios.create({
    baseURL: CHAT_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 30000,
});


chatAxios.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor (optional)
chatAxios.interceptors.response.use(
    (response) => response,
    (error) => {
        return Promise.reject(error);
    }
);

export const chatAxios_post = async (url, payLoad = {}, config = {}) => {
    try {
        const response = await chatAxios.post(url, payLoad, config);
        printChatDebugLog(`${url}`, response.data);
        return response.data;
    } catch (error) {
        console.error("chatAxios_post error:", error);
    }
    return null;
};

export const chatAxios_get = async (url, config = {}) => {
    try {
        const response = await chatAxios.get(url, config);
        printChatDebugLog(`${url}`, response.data);
        return response.data;
    } catch (error) {
        console.error("chatAxios_get error:", error);
    }
    return null;
};
